import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { EvaluationControllerClient, People } from '~/services/Http';

export const GET_APPRAISAL_EVALUATIONS_SWR_KEY =
  'EvaluationControllerClient.getEvaluationSummaries';

type UseGetAppraisalEvaluationsOutput = Omit<
  UseSWROutput<People.EvaluationSummaryDto[]>,
  'data'
> & {
  appraisalEvaluations: People.EvaluationSummaryDto[];
};

export function useGetAppraisalEvaluations(
  args?: {
    lang?: string;
    offset?: number;
    limit?: number;
    order?: People.Order25;
    isEnabled?: boolean;
  },
  swrConfig?: SWRConfiguration<People.EvaluationSummaryDto[]>,
): UseGetAppraisalEvaluationsOutput {
  const isEnabled = args?.isEnabled !== false;

  const { data, ...rest } = useSWR(
    isEnabled
      ? [
          GET_APPRAISAL_EVALUATIONS_SWR_KEY,
          args?.lang ?? undefined,
          args?.offset ?? undefined,
          args?.limit ?? undefined,
          args?.order ?? undefined,
        ]
      : null,
    ([_swrKey, lang, offset, limit, order]) =>
      EvaluationControllerClient.getEvaluationSummaries(
        order,
        offset,
        limit,
        lang,
      ).then((r) => r.data),
    swrConfig,
  );

  return {
    appraisalEvaluations: data ?? [],
    ...rest,
  };
}
